var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('components.modals.campaign.deleteTitle'),"action":"delete","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('div',{staticClass:"mt-4"},[_vm._v(" "+_vm._s(_vm.$t('components.modals.campaign.deleteConfirm', { name: _vm.name }))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }